import { render, staticRenderFns } from "./FirmwareVersionMapping.vue?vue&type=template&id=71cff0b9&"
import script from "./FirmwareVersionMapping.vue?vue&type=script&lang=js&"
export * from "./FirmwareVersionMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports